/* eslint-disable @typescript-eslint/no-explicit-any */
import { useSessionStorage } from '@/hooks'
import { useMemo } from 'react'
import { useGetBootstrapAppPage } from '../components/AppPage2/useGetAppPage'
import { getMatchingFilters } from '../components/AppPage2/utils'
import { useAppContext } from './useAppContext'

export function useGetFilterSelections() {
  const {
    data: { pageFilters },
  } = useGetBootstrapAppPage()
  const { pageFilterStorageKey } = useAppContext()
  const [filterSelectionsPersisted, , , isMounted] = useSessionStorage<Record<string, any>[]>(pageFilterStorageKey, [])
  const matchingFilters = useMemo(
    () => getMatchingFilters(filterSelectionsPersisted, pageFilters),
    [filterSelectionsPersisted, pageFilters]
  )
  return useMemo(
    () => ({
      filterSelections: matchingFilters,
      isMounted,
    }),
    [matchingFilters, isMounted]
  )
}
